import { useDispatch } from 'react-redux'

import { customSuccessNotification } from 'store/actions/notifications'
import { createErrorNotification } from 'store/actions/notifications'
import { refreshCounter } from 'store/actions/refresh'

import Api from 'services/Api'

const useProjectSubmit = (url: string) => {
  const dispatch = useDispatch()

  return async (payload: Record<string, unknown>) => {
    const { success, data } = await Api.put(`projects/bulk/${url}`, payload)

    if (!success) return dispatch(createErrorNotification())

    dispatch(refreshCounter('projects'))

    return customSuccessNotification(dispatch, { resourceType: 'PROJECT', isCreating: false, count: data.modifiedCount })
  }
}

export { useProjectSubmit }
